import { Filter } from "./filter-models";

export class FilterImportResults {
  importFilterError: string | null = null;
  importFilterSuccess: boolean | null = null;
  importFilterMigratedFrom: string | null = null;
  importFilterMigratedTo: string | null = null;
  importFilterExportDate: string | null = null;
  importFilterExportVersion: string | null = null;
  importFilterExportGame: string | null = null;
  importedName: string | null = null;
  filter: Filter | null = null;
}

export class FilterSectionsToUpdate {
  quickFilters = false;
  myWeapons = false;
  myArmour = false;
  myJewellery = false;
  myJewel = false;
  myFlasks = false;
  appendToMyEquipment = false;
  tierCosmetics = true;
  customCosmeticRules = true;
  appendToCustomCosmeticRules = false;
  customRules = false;
  appendToCustomRules = false;
  freeRules = false;
  customCurrencyAndDivCardTiers = false;
  customUniqueTiers = false;
  customChanceBaseTiers = false;
  customGearTiers = false;
  customJewelleryTiers = false;
  customModTiers = false;
  customEquipmentTiers = false;
  identifiedItemConfigs = false;
  tieringModeCustom = false;
  uniquesTieringModeCustom = false;
}
